module.exports = "/fonts/HelveticaNeueBoldItalic.woff?56355ffe78924a3e90185fafc3c2c638";